var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F0F3F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10V22H22V10H10Z",
    fill: "#1C8FF8",
    fillOpacity: 0.338428
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2941 12.3997C20.2941 13.4428 20.2037 17.5567 20.1466 20.0481C20.1218 21.1338 19.2343 21.9995 18.1484 21.9995H14.0965C13.0076 21.9995 12.1188 21.1284 12.0969 20.0397L11.9434 12.3997",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 12.3997H11.943H21.4867",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7324 12.4V11.2C13.7324 10.5373 14.2665 10 14.9254 10H17.3113C17.9702 10 18.5043 10.5373 18.5043 11.2V12.4",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9258 15.4005V19.0004",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3105 15.4005V19.0004",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ab49085bf4ebc5f3311543f4081b27f6.svg";
export { ForwardRef as ReactComponent };